<template>
  <MultiStepFormComponent
    :totalSteps="6"
    @form-submitted="handleFormSubmission"
    ref="multiStepForm"
  >
    <template v-slot:step-1="{ onValidityChanged }">
      <StepOneApplicationTypeComponent @validity-changed="onValidityChanged" />
    </template>

    <template v-slot:step-2="{ onValidityChanged }">
      <StepTwoGroupInformationComponent @validity-changed="onValidityChanged" />
    </template>

    <template v-if="formStore.shouldShowStep(3)" v-slot:step-3="{ onValidityChanged }">
      <StepThreePracticesComponent @validity-changed="onValidityChanged" />
    </template>

    <template v-if="formStore.shouldShowStep(4)" v-slot:step-4="{ onValidityChanged }">
      <StepFourLocationsComponent @validity-changed="onValidityChanged" />
    </template>

    <template v-if="formStore.shouldShowStep(5)" v-slot:step-5="{ onValidityChanged }">
      <StepFiveProvidersComponent @validity-changed="onValidityChanged" />
    </template>

    <template v-slot:step-6="{ onValidityChanged }">
      <StepSixAgreement @validity-changed="onValidityChanged" />
    </template>
  </MultiStepFormComponent>
  <!-- Debug Info
  <div class="Grid-cell u-size1of3">
      <details class="debug-section">
          <summary>Submission Data (Debug)</summary>
          <pre>{{ formStore.submissionData }}</pre>
      </details>
  </div>
  -->
</template>

<script setup>
import MultiStepFormComponent from './components/MultiStepFormComponent.vue'
import StepOneApplicationTypeComponent from './components/steps/StepOneApplicationTypeComponent.vue'
import StepTwoGroupInformationComponent from './components/steps/StepTwoGroupInformationComponent.vue'
import StepThreePracticesComponent from './components/steps/StepThreePracticesComponent.vue'
import StepFourLocationsComponent from './components/steps/StepFourLocationsComponent.vue'
import StepFiveProvidersComponent from './components/steps/StepFiveProvidersComponent.vue'
import StepSixAgreement from './components/steps/StepSixAgreement.vue'

import { useFormStore } from './stores/formStore'

const formStore = useFormStore()

function handleFormSubmission() {
  // Handle form submission logic here
  console.log('Form submitted event received')
  console.log(JSON.stringify(formStore.submissionData, null, 2))
}
</script>
